import React from "react";
import classNames from "classnames";

const getSearchParameter = () => {
  let type = localStorage.getItem("searchElement");
  return type;
};
const getHighlightedText = (text, highlight) => {
  // Split text on highlight term, include term itself into parts, ignore case
  if (text) {
    let parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <span>
        {parts.map((part) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span style={{ background: "yellow" }}>{part}</span>
          ) : (
            part
          ),
        )}
      </span>
    );
  }
};
export default function ClaimantsInfo(props) {
  const { claimantDetails } = props.data;

  return (
    <div className="card mt-2" style={{ border: "none" }}>
      <div
        className={"card-body"}
        style={{
          borderRadius: "4px",
          backgroundColor: "#f5fbff",
          padding: "15px 12px 15px 12px",
        }}
      >
        {claimantDetails.map((claimant, index) => {
          return (
            <div key={index} className={"row mt-1"}>
              <div className={"col-md-2"}>
                <div className={"search-label"}>Claimant {index + 1}</div>
                <div className={"search-items-content-vin"}>
                  {/* {claimant.claimantName} */}

                  {getSearchParameter() === "claimantName"
                    ? getHighlightedText(
                        claimant.claimantName,
                        props.defaultSearchValue,
                      )
                    : claimant.claimantName}
                </div>
              </div>
              <div className={"col-md-1"}>
                <div className={"search-label"}>Peril</div>
                <div className={"search-items-content-vin"}>
                  {claimant.perilDesc}
                </div>
              </div>
              <div className={"col-md-1"}>
                <div className={"search-label"}>Status</div>
                <div className={"search-items-content-vin"}>
                  <span
                    title={claimant.status}
                    className={classNames({
                      "status-label closed-status":
                        claimant.status === "CLOSED",
                      "status-label record_only-status":
                        claimant.status === "RECORD ONLY",
                      "status-label salvage-status":
                        claimant.status === "SALVAGE PENDING",
                      "status-label subro-status":
                        claimant.status === "SUBRO PENDING",
                      "status-label open-status": claimant.status === "OPEN",
                    })}
                  >
                    {claimant.status}
                  </span>
                </div>
              </div>
              <div className={"col-md-1"}>
                <div className={"search-label"}>Adjuster</div>
                <div className={"search-items-content-vin"}>
                  {claimant.adjuster}
                </div>
              </div>
              <div className={"col-md-1"}>
                <div className={"search-label"}>Phone No.</div>
                <div className={"search-items-content-vin"}>
                  {claimant.clmntHome}
                </div>
              </div>
              <div className={"col-md-2"}>
                <div className={"search-label"}>Coverage Investigation?</div>
                <div className={"search-items-content-vin"}>
                  {claimant.isCovInvestigation ? "Y" : "N"}
                </div>
              </div>
              <div className={"col-md-1"}>
                <div className={"search-label"}>Claimant Limit</div>
                <div className={"search-items-content-vin"}>
                  {claimant.claimantLimit}
                </div>
              </div>
              <div className={"col-md-2"}>
                <div className={"search-label"}>Claimant Balance</div>
                <div className={"search-items-content-vin"}>
                  {claimant.claimantBalance}
                </div>
              </div>
              <div className={"col-md-1"}>
                <div className={"search-label"}>Attronery</div>
                <div className={"search-items-content-vin"}>
                  {claimant.attorney}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
